import { Component, Input, OnInit } from '@angular/core';
import { TransportExtraConditionControls } from '../../../../../../models/transport-extra-condition.controls';
import { IRefAdr } from '../../../../../../models/ref-adr.model';
import { FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { mapAsBody } from '../../../../util/request-util';
import { AdrPacking } from '../../../../../../models/enums/adr-packing.enum';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { RefAdrExtendedService } from '../../../../../../services/ref-adr-extended.service';
import { IGenericBaryFormGroup } from '../../../../../../models/forms/GenericBaryFormGroup';
import { OptionType } from '../../../../../../models/option-type';

@Component({
  selector: 'jhi-bary-modal-add-or-update-adr',
  templateUrl: './bary-modal-add-or-update-adr.component.html',
  styleUrls: ['./bary-modal-add-or-update-adr.component.scss'],
})
export class BaryModalAddOrUpdateAdrComponent implements OnInit {
  @Input() transportExtraConditionForm!: IGenericBaryFormGroup<TransportExtraConditionControls>;
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();

  refADRUNOptions: OptionType[] = [];
  filteredADR: Map<number, IRefAdr[]> = new Map<number, IRefAdr[]>();
  filteredDescriptionOptions: Map<number, OptionType[]> = new Map<number, OptionType[]>();
  filteredPackingGroupOption: Map<number, OptionType[]> = new Map<number, OptionType[]>();
  packingOptions: OptionType[] = [];

  constructor(private refAdrService: RefAdrExtendedService, private modalRef: MDBModalRef) {}

  ngOnInit(): void {
    this.initExtraConditions();
    this.getPackingOptions();
    this.setRequire(this.transportExtraConditionForm.controls.adrIsWaste.value);
    this.transportExtraConditionForm.controls.adrIsWaste.valueChanges.subscribe(checked => this.setRequire(checked));
  }

  getByCriteria(transportExtraConditionForm: IGenericBaryFormGroup<TransportExtraConditionControls>, codeUn: string, index: number): Subscription | null {
    if (codeUn) {
      return this.refAdrService
        .query({ 'codeUN.equals': Number.parseInt(codeUn, 10) })
        .pipe(mapAsBody)
        .subscribe((adrs: IRefAdr[]) => {
          this.filteredADR.set(index, adrs);
          const set = new Set(adrs.map((it: IRefAdr) => it.description!));
          // only unique description
          const data = [...set].map(it => ({ value: it, label: it }));

          if (data.length === 1) {
            this.setToUniqueResult(transportExtraConditionForm.controls.adrDescription, data[0].value);
          }
          this.filteredDescriptionOptions.set(index, data);

          this.filterPackingGroup(transportExtraConditionForm, adrs, index);
        });
    }
    return null;
  }

  setToUniqueResult(control: FormControl, value: any): void {
    if (control.value !== value) {
      control.setValue(value);
    }
  }

  initExtraConditions(): void {
    this.getByCriteria(this.transportExtraConditionForm, this.transportExtraConditionForm.controls.adrCodeUN.value, 0);
    this.defineQuantitiesLimitedRequires(this.transportExtraConditionForm.controls.adrIsLimitedQuantity.value);
    this.transportExtraConditionForm.controls.adrIsLimitedQuantity.valueChanges.subscribe(value => this.defineQuantitiesLimitedRequires(value));
  }

  filterPackingGroup(transportExtraConditionForm: IGenericBaryFormGroup<TransportExtraConditionControls>, adrs: IRefAdr[], index: number): void {
    if (transportExtraConditionForm.controls.adrDescription.value) {
      const data: OptionType[] = adrs
        .filter(it => transportExtraConditionForm.controls.adrDescription.value === it.description)
        .filter(it => !!it.packingGroup)
        .map((it: IRefAdr) => ({ label: it.packingGroup!, value: it.packingGroup! }));

      if (data.length === 1) {
        this.setToUniqueResult(transportExtraConditionForm.controls.adrPackingGroup, data[0].value);
        this.filteredPackingGroupOption.set(index, data);
      } else if (data.length === 0) {
        this.transportExtraConditionForm.controls.adrPackingGroup.removeValidators(Validators.required);
        this.transportExtraConditionForm.controls.adrPackingGroup.updateValueAndValidity();
      } else {
        this.filteredPackingGroupOption.set(index, data);
      }
    }
  }

  private defineQuantitiesLimitedRequires(value: boolean): void {
    if (value) {
      // c'est une quantité limitée, seul le poids est nécessaire
      this.transportExtraConditionForm.controls.adrCodeUN.removeValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrCodeUN.disable();
      this.transportExtraConditionForm.controls.adrCodeUN.reset();
      this.transportExtraConditionForm.controls.adrDescription.removeValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrDescription.disable();
      this.transportExtraConditionForm.controls.adrDescription.reset();
      this.transportExtraConditionForm.controls.adrPacking.removeValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrPacking.disable();
      this.transportExtraConditionForm.controls.adrPacking.reset();
      this.transportExtraConditionForm.controls.adrPackingGroup.removeValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrPackingGroup.disable();
      this.transportExtraConditionForm.controls.adrPackingGroup.reset();
      this.transportExtraConditionForm.controls.adrPackingNumber.removeValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrPackingNumber.disable();
      this.transportExtraConditionForm.controls.adrPackingNumber.reset();
      this.transportExtraConditionForm.controls.adrIsDangerousForEnvironment.reset();
      this.transportExtraConditionForm.controls.adrIsDangerousForEnvironment.disable();
      this.transportExtraConditionForm.controls.adrIsWaste.reset();
      this.transportExtraConditionForm.controls.adrIsWaste.disable();
    } else {
      // ce n'est pas une quantité limitée
      this.transportExtraConditionForm.controls.adrCodeUN.addValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrCodeUN.enable();
      this.transportExtraConditionForm.controls.adrDescription.addValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrDescription.enable();
      this.transportExtraConditionForm.controls.adrPacking.addValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrPacking.enable();
      this.transportExtraConditionForm.controls.adrPackingGroup.addValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrPackingGroup.enable();
      this.transportExtraConditionForm.controls.adrPackingNumber.addValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrPackingNumber.enable();
      this.transportExtraConditionForm.controls.adrIsDangerousForEnvironment.enable();
      this.transportExtraConditionForm.controls.adrIsWaste.enable();
    }
    this.transportExtraConditionForm.getAngularForm().updateValueAndValidity();
  }

  getPackingOptions(): void {
    this.packingOptions = Object.entries(AdrPacking).map(([_, value]) => ({ label: value, value }));
  }

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  handleSubmit(action: { submit: boolean; value: any }): void {
    if (this.transportExtraConditionForm.validateForm()) {
      this.transportExtraConditionForm.controls.adrNetWeight.setValue(
        this.transportExtraConditionForm.controls.adrNetWeight.value ? Math.ceil(this.transportExtraConditionForm.controls.adrNetWeight.value) : 0
      );
      this.action.next(new BaryModalEvent(action));
      this.modalRef.hide();
    }
  }

  setRequire(checked: boolean): void {
    if (checked) {
      this.transportExtraConditionForm.controls.adrWasteBsdCode.addValidators(Validators.required);
    } else {
      this.transportExtraConditionForm.controls.adrWasteBsdCode.removeValidators(Validators.required);
      this.transportExtraConditionForm.controls.adrWasteBsdCode.reset();
    }
    this.transportExtraConditionForm.controls.adrWasteBsdCode.updateValueAndValidity();
  }

  hasPackingGroup(): boolean {
    if (this.filteredPackingGroupOption.size > 0) {
      const entry = this.filteredPackingGroupOption.entries().next();
      return entry.value.length > 0;
    }
    return false;
  }

  getPackingGroup(): OptionType[] {
    return Array.from(this.filteredPackingGroupOption.values()).at(0)!;
  }
}
